exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#Main {\n\tmargin-bottom: 7%;\n}\n\n.menu-form {\n\ttext-align: center;\n}\n\n.edit-menu-container {\n\twidth: 100%;\n\tmargin-top: 7%;\n\tmargin-bottom: 7%;\n}\n\n.menu-item {\n\ttext-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/app/pages/Edit.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/app/pages/Edit.css
// module chunks = 0